import React from 'react';
import { crewPhotos, reasons, reviews, reviewsUrl } from '../../data/referenceHome';
import { photoUrl } from '../../data/photos';

export const HomeReasons = () => (
  <section className="reference-section" id="why" data-testid="home-why"><div className="site-container">
    <div className="reference-heading"><h2>Why El Paso<br /><em>keeps coming back.</em></h2></div>
    <div className="reasons-grid">{reasons.map((reason) => <article key={reason.id} className="reference-reason" data-testid={`home-why-${reason.id}`}><h3>{reason.title}</h3><p>{reason.description}</p></article>)}</div>
  </div></section>
);

export const HomeCrew = () => (
  <section className="reference-section" id="crew" data-testid="home-crew"><div className="site-container">
    <div className="reference-heading"><h2>Real shop.<br /><em>Real crew.</em></h2><p>No stock photos. This is the actual shop, the actual crew, and the actual cars rolling through every day.</p></div>
    <div className="crew-grid">{crewPhotos.map((photo) => <figure key={photo.id} data-testid={`crew-photo-${photo.id}`}><div><img src={photoUrl(photo.id)} alt={photo.alt} loading="lazy" /></div><figcaption>{photo.caption}</figcaption></figure>)}</div>
  </div></section>
);

export const HomeReviews = () => (
  <section className="reference-section" id="reviews" data-testid="home-reviews"><div className="site-container">
    <div className="reference-heading"><h2>Performance Lube 915<br /><em>has spoken.</em></h2><p>4.9 stars from 130+ Google reviews. Here's the short version:</p></div>
    <div className="reviews-grid">{reviews.map((review) => <figure className="reference-review" key={review.id} data-testid={`home-review-${review.id}`}>
      <span className="review-stars" aria-label="5 stars">★★★★★</span><blockquote>“{review.quote}”</blockquote><figcaption><b>{review.author}</b> · Google review</figcaption>
    </figure>)}</div>
    <a className="google-reviews-link" href={reviewsUrl} target="_blank" rel="noopener noreferrer" data-testid="home-google-reviews-link"><span className="review-stars" aria-hidden="true">★</span> Posted on Google — read all 130+ reviews on our Google Business profile</a>
  </div></section>
);